export const CLOUD_FUNCTIONS = {
  SEND_MESSAGE: 'userSendContactUsForm',
};
